/**
 * @generated SignedSource<<c7410a70af97403db2666c59f42da2b8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EventOwnerPicker_user$data = {
  readonly firstName: string;
  readonly guildsForNewEvents: {
    readonly nodes: ReadonlyArray<{
      readonly defaultTimeZone: string | null | undefined;
      readonly name: string;
      readonly networks: {
        readonly nodes: ReadonlyArray<{
          readonly name: string;
        } | null | undefined>;
      };
      readonly rowId: string;
      readonly " $fragmentSpreads": FragmentRefs<"EventOwnerPickerGuildOption_guild">;
    } | null | undefined>;
  };
  readonly lastName: string;
  readonly rowId: string;
  readonly " $fragmentSpreads": FragmentRefs<"UserPrimaryPhotoNew_user">;
  readonly " $fragmentType": "EventOwnerPicker_user";
};
export type EventOwnerPicker_user$key = {
  readonly " $data"?: EventOwnerPicker_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"EventOwnerPicker_user">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rowId",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EventOwnerPicker_user",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastName",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "UserPrimaryPhotoNew_user"
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 500
        }
      ],
      "concreteType": "GuildsConnection",
      "kind": "LinkedField",
      "name": "guildsForNewEvents",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Guild",
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "defaultTimeZone",
              "storageKey": null
            },
            {
              "alias": "networks",
              "args": [
                {
                  "kind": "Literal",
                  "name": "first",
                  "value": 20
                },
                {
                  "kind": "Literal",
                  "name": "membershipStatus",
                  "value": "ACCEPTED"
                }
              ],
              "concreteType": "GuildsConnection",
              "kind": "LinkedField",
              "name": "rankedNetworks",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Guild",
                  "kind": "LinkedField",
                  "name": "nodes",
                  "plural": true,
                  "selections": [
                    (v1/*: any*/)
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": "rankedNetworks(first:20,membershipStatus:\"ACCEPTED\")"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "EventOwnerPickerGuildOption_guild"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "guildsForNewEvents(first:500)"
    }
  ],
  "type": "User",
  "abstractKey": null
};
})();

(node as any).hash = "b0d28152ad54e916905f9fde3f23c3ea";

export default node;
